<div class="card">
  <h1><span i18n="@@passwordEntry.title">Enter your password</span></h1>
  <form [formGroup]="form" id="login-form">
    <div class="input-container">
      <zaver-animated-form-input
        [size]="'large'"
        placeholder="Enter business email"
        i18n-placeholder="@@passwordEntry.form.email.placeholder"
        [inputMode]="'email'"
        [error]="form.controls.email.invalid && showError"
        errorMessage="Please enter a valid email address"
        i18n-errorMessage="@@passwordEntry.form.email.errorMessage"
        formControlName="email"
        [readonly]="processingLogin"
      ></zaver-animated-form-input>
    </div>

    <div class="input-container">
      <zaver-animated-form-input
        [size]="'large'"
        placeholder="Enter your password"
        i18n-placeholder="@@passwordEntry.form.password.placeholder"
        [inputType]="'password'"
        [error]="form.controls.password.invalid && showError"
        errorMessage="Please enter your password"
        i18n-errorMessage="@@passwordEntry.form.password.errorMessage"
        formControlName="password"
        [readonly]="processingLogin"
      ></zaver-animated-form-input>
    </div>

    <div class="switch-container">
      <app-switch
        (change)="rememberMeClicked()"
        text="Remember me"
        i18n-text="@@passwordEntry.rememberMe.text"
        formControlName="rememberMe"
      ></app-switch>
    </div>
    <app-form-error *ngIf="formError" [errorText]="formError"> </app-form-error>

    <div class="button-wrapper">
      <zaver-primary-button
        [buttonType]="'submit'"
        text="Sign in"
        i18n-text="@@passwordEntry.button.submit"
        [loading]="processingLogin"
        [color]="'cerise'"
        (click)="submit()"
      ></zaver-primary-button>
    </div>
  </form>
</div>
<div id="signup-box">
  <span
    (click)="resetPassword()"
    class="link"
    i18n="@@passwordEntry.forgotPassword.text"
    >Forgot password?</span
  >
</div>
